import { useMap, Marker, Popup, Tooltip } from "react-leaflet";
import { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import ApiService from "../../services/apiService";
import ChackComponent from "./ChackComponent";

const getCustomMarker = (dateTime: any) => {
  const apiTime = new Date(String(dateTime).replace(" ", "T"));
  const diffHours = (new Date().getTime() - apiTime.getTime()) / (1000 * 60 * 60);
  const color = diffHours > 2 ? "#F7374F" : "#89AC46";   // red = offline, green = online

  return L.divIcon({
    className: "",
    html: `<div class="circle-marker" style="background-color:${color}; width:20px; height:20px; border-radius:50%; border:2px solid white; box-shadow:0 0 4px rgba(0,0,0,0.4);"></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
};

const DemoDeviceLayer = () => {
  const map = useMap();
  const [devices, setDevices] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<number >(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const res = await ApiService.axiosApi("DemoDevice/GetAllDemoDevice", { method: "GET" });
        if (res.success) setDevices(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchDevices();
   
  }, []);

  return (
    <>
      <MarkerClusterGroup>
        {devices.map((device) => {
          const lat = parseFloat(device.latitude);
          const lng = parseFloat(device.longitude);
          if (isNaN(lat) || isNaN(lng)) return null;

          return (
            <Marker
              key={device.id}
              position={[lat, lng]}
              icon={getCustomMarker(device.serverDateTime)}
              eventHandlers={{
                click: () => {
                  setSelectedId(device.id);
                  setIsOpen(true);
                },
              }}
            >
              <Tooltip>
                <table className="table-striped" style={{ width: "100%", height: "100%" }}>
                  <tbody>
                    <tr><th>Device</th>      <td>{device.deviceName}</td></tr>
                    <tr><th>Battery</th>     <td>{device.batteryVoltage}V</td></tr>
                    <tr><th>Solar</th>       <td>{device.solarVoltage}V</td></tr>
                    <tr><th>Temperature</th> <td>{device.temperature}°C</td></tr>
                    <tr><th>Pressure 1</th>  <td>{device.pressureTransmitter1} Bar</td></tr>
                  </tbody>
                </table>
              </Tooltip>
            </Marker>
          );
        })}
      </MarkerClusterGroup>

      <Modal 
  isOpen={isOpen} 
  toggle={() => setIsOpen(false)} 
  size="xl" 

  centered
  className="chack-modal"
>
  <ChackComponent id={selectedId} onClose={() => setIsOpen(false)} />
</Modal>
    </>
  );
};

export default DemoDeviceLayer;